function makeEmptyCaption() {
  return {
    authorOrArtist: {
      value: "",
      showOutsideContext: false,
      showInContext: false
    },
    caption: { value: "", showOutsideContext: false, showInContext: false },
    copyright: { value: "", showOutsideContext: false, showInContext: false },
    country: { value: "", showOutsideContext: false, showInContext: false },
    description: { value: "", showOutsideContext: false, showInContext: false },
    duration: { value: "", showOutsideContext: false, showInContext: false },
    numberOfPages: {
      value: "",
      showOutsideContext: false,
      showInContext: false
    },
    title: { value: "", showOutsideContext: false, showInContext: false },
    year: { value: "", showOutsideContext: false, showInContext: false }
  };
}

export { makeEmptyCaption };
//# sourceMappingURL=util.empty-cation.js.map
